import cookie from "cookie";
import consts from "consts";
import qs from "qs";
import fetch from "fetch";
import store from "store2";
import ua from "ua";
var host = {};
if (process.browser) {
  host = window;
}

var Promise;
if (!host.Promise) {
  let vendorPromise = require("vendors/promise-polyfill");
  host.Promise = Promise = vendorPromise;
} else {
  Promise = host.Promise;
}

function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

let pageUUID = uuid();

var dvidSetPromise = null;
var pnlogger =
  host.pnlogger ||
  (function () {
    return {
      sendEvent(action, key) {
        this.send(action, key);
        window.ga && window.ga("send", "event", key, action);
      },
      sendPV(page) {
        this.send("浏览", "", page);
        window.ga && window.ga("send", "pageview", page);
      },
      sendClick(key) {
        this.send("点击", key);
      },
      sendPageLog(actionKey) {
        const pageLogOn = false;
        let key = actionKey + "/" + pageUUID;
        if (pageLogOn) {
          this.send("debug", key, location.href);
        } else {
          // console.log(key)
        }
      },
      send(action, key, url) {
        if (ua.isBeta()) {
          return false;
        }
        if (cookie.get("dvid")) {
          this._send(action, key, url);
          return;
        }
        if (!dvidSetPromise) {
          dvidSetPromise = new Promise((resolve) => {
            fetch({
              url: "/v1/setDvid",
            }).then(() => {
              resolve();
            });
          });
        }
        dvidSetPromise.then(() => {
          this._send(action, key, url);
        });
      },

      _send(action, key, url) {
        var data = {
          url: url || location.href,
          referer: document.referrer,
          clientType: consts.clientType,
        };
        var dvid = cookie.get("dvid");
        var userId = cookie.get("pnid");
        var cityId = cookie.get("cityId");
        var channel = qs.query.channel || cookie.get("channel");
        if (cityId) {
          data.cityId = cityId;
        }
        if (action) {
          data.action = action;
        }
        if (key) {
          data.key = key;
        }
        if (dvid) {
          data.dvid = dvid;
        }
        if (userId) {
          data.userId = userId;
        }
        if (channel) {
          data.channel = channel;
        }
        function sendImg() {
          var img = new Image();
          img.onload = function () {
            // console.log(data.key)
            store.set("unlogger", "");
          };
          img.src = "https://track.piaoniu.com/log?" + qs.stringify(data);
          store.set("unlogger", {
            url: data.url,
            action: data.action,
            key: data.key,
          });
        }
        sendImg();
      },

      onSendEvent(value = {}) {
        console.log("*****logger********", value);
        // if (ua.isBeta()) {
        //   return false
        // }
        const keys = Object.keys(value || {});
        const params = keys.length ? value : {};
        const { action, key, url } = params;
        Object.assign(params, {
          action: action || "unknown",
          key: key || null,
          url: url || location.href,
          channel: qs.query.channel || cookie.get("channel"),
          clientType: consts.clientType,
          ua: navigator.userAgent,
          dvid: cookie.get("dvid") || "",
          cityId: cookie.get("cityId") || 0,
          userId: cookie.get("pnid") || 0,
          referrer: document.referrer,
        });
        function sendImg() {
          var img = new Image();
          img.onload = function () {
            store.set("unlogger", "");
          };
          img.src = "https://track.piaoniu.com/log?" + qs.stringify(params);
          store.set("unlogger", {
            url: params.url,
            action: params.action,
            key: params.key,
          });
        }
        sendImg();
      },
      /**
       * @description 2024年定义的打点规范
       * @param {action: LOG_ACTION, key: 触发事件的元素或元素ID, url, schema: PAGE_NAME, scheaname: 页面标题, params: 页面参数，业务所需扩展数据} value
       */
      onTrack(value = {}) {
        const keys = Object.keys(value || {});
        let loggerData = keys.length ? value : {};
        const { action, key, keyname, url, schema, schemaname, params = {} } = loggerData;
        const properties = {
          distinctId: "",
          deviceBrand: "",
          deviceModel: "",
          os: navigator.userAgent,
          osVersion: navigator.userAgent,
          screen_height: screen.height,
          screen_width: screen.width,
        };
        params.keyname = keyname;
        params.schemaname = schemaname;
        params.referer_model = document.referrer;
        params.referer_modelID = document.referrer;
        params.properties = properties;
        const originSource = sessionStorage.getItem("originSource");
        if (!params.originSource && originSource) {
          params.originSource = originSource;
        }
        loggerData = {
          requestId: uuid(),
          action: action || "",
          key: key,
          schema: schema,
          url: url || location.href,
          urlhost: location.host,
          time: new Date(),
          dvid: cookie.get("dvid"),
          ua: navigator.userAgent,
          referer: document.referrer,
          channel: qs.query.channel || cookie.get("channel"),
          clientType: consts.clientType,
          appVersion: navigator.appversion,
          cityId: cookie.get("cityId") || 0,
          userId: cookie.get("pnid") || 0,
          // params: JSON.stringify(params),
          paramsJsonStr: JSON.stringify(params),
        };
        // console.log('loggerData', loggerData);
        function sendImg() {
          var img = new Image();
          img.onload = function () {
            store.set("unlogger", "");
          };
          // img.src = 'https://track.piaoniu.com/log?' + encodeURIComponent(qs.stringify(loggerData))
          img.src = "https://track.piaoniu.com/log?" + qs.stringify(loggerData);

          store.set("unlogger", {
            url: loggerData.url,
            action: loggerData.action,
            key: loggerData.key,
          });
        }
        sendImg();
      },
    };
  })();

host.pnlogger = pnlogger;

if (store.get("unlogger")) {
  let unlogger = store.get("unlogger");
  pnlogger.send(unlogger.action, unlogger.key, unlogger.url);
}

if (process.browser) {
  pnlogger.sendPV();

  // 测试https
  var httpsTestImage = new Image();
  httpsTestImage.onerror = function () {
    throw new Error("https图片打点失败");
  };
  httpsTestImage.src = "https://static.piaoniu.com/m/ui/downloadbar/img/logo.1c3e9153.png";
}
export const LOG_ACTION = {
  start: "start", // 启动app或从后台切换进入app时触发
  end: "end", // 退出app
  enter: "enter", // 打开一个Activity / ViewController 页面时触发 或者点击某一个链接跳转进入页面
  click: "click", // 点击控件时触发
  install: "install",
  crashe: "crashe", // app 崩溃
  launch: "launch", // 其他平台通过后台唤起APP时触发点
  pushclick: "pushclick", // 推送被点击时触发
  leave: "leave", // 离开页面后， 上报页面离开事件
  popupdisplay: "popupdisplay", // 弹窗展示时触发
  popupclick: "popupclick", // 点击弹窗时触发
};
export const PAGE_NAME = {
  startScreenPage: "start_screen_page", // 开屏页
  loginPage: "login_page", // 登录页
  ipListPage: "ipList_page", // IP列表页
  ipDetailPage: "ip_page", // IP列表页
  homePage: "home_page", // 首页
  categoryPage: "category_page", // 分类页面
  minePage: "mine_page", // 我的页面
  searchPage: "search-page", // 搜索页面
  discoverPage: "discover_page", // 发现页面
  activityDetailPage: "activityDetail_page", // 演出详情页面
  videoViewPage: "video_view_page", // 视频浏览页面
  eventTicketGroupPage: "event_ticket_group_page", // 场次票档页
  ipPage: "ip_page", // 小站页
  orderDetailPage: "order_detail_page", // 订单详情页
};
export default pnlogger;



// WEBPACK FOOTER //
// ./src/mods/logger.js